import { render } from "./icon_menuplan.svg?vue&type=template&id=7d4ba820?inline"
const script = {}
script.render = render

export default script